<template>
  <div class="intro">
    <div class="d-flex justify-content-end">
      <button
        @click="save"
        class="ui-action-button"
        :disabled="isUpdating"
      >
          {{ $t("global.saveChanges") }}
          <b-spinner class="ml-1" small label="loading" v-if="isUpdating"></b-spinner>
      </button>
    </div>
    <div class="intro__content">
      <label class="text-black">{{ $t("integrityCompliance.integrity.intro") }}</label>
      <Wysiwyg
        :articleBody="intro.originalDescription"
        :includeMediaContent="false"
        v-on:updateBody="intro.description = $event"
        :placeholder="$t('integrityCompliance.body_ph')"
      />
      <div class="ui-input-error-msg">
        <span v-if="$v.intro.description.$error">{{ $t("global.inputs.required") }}</span>
      </div>

      <div class="intro__content--section">
        <label class="text-black">{{ $t("integrityCompliance.intro.director_message") }}</label>
        <div class="input-container">
          <label>{{ $t("newAlert.alertImage") }}</label>
          <FileUploader
            :key="fileUploaderKey"
            :placeholder="$t('newAlert.alertImagePH')"
            :type="'image/*'"
            :validate="'image/'"
            :label="$t('global.browse')"
            :fileUrl="intro.imageUrl"
            @setFile="setFile"
          />
          <div class="ui-input-error-msg">
            <span v-if="$v.file.$error">{{ $t("global.inputs.required") }}</span>
          </div>
        </div>
        <Wysiwyg
          :articleBody="intro.originalQuote"
          :includeMediaContent="false"
          v-on:updateBody="intro.quote = $event"
          :placeholder="$t('integrityCompliance.body_ph')"
        />
        <div class="ui-input-error-msg">
          <span v-if="$v.intro.quote.$error">{{ $t("global.inputs.required") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const Wysiwyg = () => import("@/components/Wysiwyg");
const FileUploader = () => import("@/components/FileUploader");
import { requiredIf } from "vuelidate/lib/validators";
import { integrityComplianceKey, ICfilesName } from "@/lib/constants.js";
import { validateBody } from '@/lib/utils.js'
import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();

export default {
  components: {
    Wysiwyg,
    FileUploader
  },
  data: function () {
    return {
      fileUploaderKey: new Date().getTime(),
      isLoading: false,
      isUpdating: false,
      intro: {
        title: ICfilesName['intro'],
        description: {
          ops: []
        },
        originalDescription: {
          ops: []
        },
        quote: {
          ops: []
        },
        originalQuote: {
          ops: []
        },
        imageUrl: ''
      },
      file: null
    }
  },
  validations: {
    intro: {
      description: {
        isRequired: function(data) {
          return validateBody(data)
        }
      },
      quote: {
        isRequired: function(data) {
          return validateBody(data)
        }
      }
    },
    file: {
      required: requiredIf(function() {
        if (this.intro.imageUrl) {
          return false;
        } else {
          return true;
        }
      })
    }
  },
  mounted () {
    this.getHome()
  },
  methods: {
    async getHome () {
      try {
        this.isLoading = true;
        const intro = await api.getHome();
        if (intro) {
          this.intro = {
            ...intro,
            originalDescription: intro.description,
            originalQuote: intro.quote
          };
        }
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('integrityCompliance.intro.getError'),
          show: true,
          type: "error"
        });
      } finally {
        this.isLoading = false;
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$error) return;

      try {
        this.isUpdating = true;
        const savedS3File = {
          srcBucket: s3.getBucketName(),
          src: this.intro.imageUrl
            ? s3.getS3KeyFromUrl(this.intro.imageUrl)
            : ''
        }
        if (this.file){
          const { Bucket, Key } = await this.saveFileToS3(this.file)
          savedS3File.srcBucket = Bucket;
          savedS3File.src = Key
        }

        const params = {
          title: this.intro.title,
          description: this.intro.description,
          quote: this.intro.quote,
          srcBucket: savedS3File.srcBucket,
          src: savedS3File.src
        }

        const response = await api.updateHome(params);
        this.intro.imageUrl = response.image_url;

        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('global.successSaved'),
          show: true,
          type: "success"
        });

      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('integrityCompliance.intro.saveError'),
          show: true,
          type: "error"
        });
      } finally {
        this.isUpdating = false;
      }
    },
    async saveFileToS3 (file) {
      if (!file) return;
      try {
        const timestamp = Date.now();
        const fileType = file.type.split('/')[1];
        const filename = `IC/${integrityComplianceKey.main}/${timestamp}.${fileType}`;
        const response = await s3.uploadFile(filename, file);
        return response;
      } catch (error) {
        throw error;
      }
    },
    setFile(file) {
      this.file = file
      if (!file) {
        this.fileUploaderKey = `fileUploader_${new Date().getTime()}`
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.intro {
  width: 100%;
  &__content {
    max-width: 80%;
    &--section {
      margin-top: $global_padding;
    }
  }
}


.input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: $global_padding 0px;

    label {
        @extend %audi-b;
    }
}
</style>
